import { purple } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

const darkTheme = createMuiTheme({
  palette: {
    primary: {
      type: "dark",
      // Purple and green play nicely together.
      main: purple[500],
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#11cb5f",
    },
  },
});

const styles = (theme) => ({
  // Formatting for AdSense at bottom (experimentation)
  root: {
    // backgroundColor:'blue',
    background: "linear-gradient(#009B4D,transparent)",

    fontFamily: "Product Sans",
    color: "#444444",
  },

  aboutPageRoot: {
    fontFamily: "Product Sans",
    padding: "30px",
    color: "#444444",
    opacity: 0.8,
  },
  appBar: {
    position: "relative",
    opacity: 0.7,
    // backgroundColor:'white'
  },

  homeButton: {
    position: "relative",
    paddingTop: "4px",
    // margin: '0 16px',
    backgroundColor: "#F5F5F5",
    fontSize: "30px",
    fontWeight: "bold",
    border: "0ch",
    "&:hover": {
      cursor: "pointer",
    },
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  secondRow: {
    flexGrow: 1,
    position: "relative",
    minHeight: "300px",
    flexFlow: "row nowrap",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0.7,
    width: '100%'
  },

  firstRow: {
    flexGrow: 1,
    position: "relative",
    minHeight: "300px",
    flexFlow: "row nowrap",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0.8,
    width: '100%'
  },

  inputCommandGrid: {
    height: "100%",
    flexGrow: 2,
    minHeight: 150,

    fontSize: "100rem",
    // paddingLeft:3
  },
  translationPlaceholder: {
    color: "#878787",
    display: "block",
    paddingLeft: 10,
  },
  outputCommandGrid: {
    backgroundColor: "#F5F5F5",
    // fontFamily: 'Roboto',
    height: "100%",

    minHeight: 150,
    justifyContent: "center",
    alignItems: "center",
  },
  row: {
    flexGrow: 1,
    // background: 'blue',
    border: 0,
    borderRadius: 3,
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: "white",
    height: 48,
    // padding: '30px',
    textAlign: "center",
    // padding: theme.spacing(1,30, 30, 30 ),
    minWidth: 275,
  },

  title: {
    fontSize: 30,
    marginLeft: 10,
    font: "Google Sans",
  },
  pos: {
    marginBottom: 12,
  },

  // Formatting for the Title
  commandTitle: {
    flexGrow: 1,
    background: "#90CAF9",
    border: 0,
    borderRadius: 3,
    color: "#333333",
    height: 30,
    textAlign: "left",
    padding: theme.spacing(1.5),
    fontSize: 24,
    font: "Google Sans",
    justifyContent: "flex-end",
    paddingLeft: 16,
    fontWeight: "bold",
  },

  mainGrid: {
    justifyContent: "center",
    // margin: '1em'
  },
  inputField: {
    width: "50",
    position: "relative",
    textAlign: "center",
    // padding: theme.spacing.unit * 3,
    /* background-color: #61dafb, */
    transition: "0.3s all",
    minHeight: "28px",
    paddingTop: "3px",
    paddingBottom: "3px",
    fontSize: "20",
    lineHeight: 20,
    display: " table-cell",
    color: "#333333",
    background: 0,
    border: 0,
    boxShadow: 0,
    // padding: '5px 12px',
    fontSize: "14px",
    lineHeight: 20,
    color: "green",
    verticalAlign: "middle",
    backgroundColor: "#fff",
    backgroundRepeat: "no-repeat",
    // overflow: 'auto hidden',
    boxSizing: "border-box",
    height: "70px",
    direction: "ltr",
    // paddingBottom: '18px',
    borderRadius: "6px",
    boxShadow: "inset 0 1px 0 rgba(225,228,232,.2)",
  },

  // Formatting for the paper Material that hosts the Toolbars
  paper: {
    // padding: theme.spacing(2),
    background: "white",
    paddingLeft: 16,
    textAlign: "horizontal",
  },

  // Formatting for the cards that host the description
  boot: {
    minWidth: 275,
    background: "#424242",
  },
  toolbar: {
    flexWrap: "wrap",
    maxHeight: 150,
  },

  // Formatting for "Configuration"
  pos: {
    marginBottom: 12,
    color: "#C7C7C7",
  },

  // Formatting for "gcloud congis list" and "aws config list"
  white: {
    color: "#FFFFFF",
  },
  // Formatting for "Learn More" Buttoms
  learnmore: {
    color: "#C7C7C7",
  },
  // Formatting for Buttons
  margin: {
    color: "ffffff",
    paddingRight: 10,
  },

  // Formatting for Buttons
  symbols: {
    outline: "FFFFFF",
    color: "white",
    outlineColor: "white",
    outlineWidth: 1,
  },

  // Formating for Outcome Toolbar
  outcome: {
    background: "white",
    color: "white",
    outline: "white",
    outlineColor: "white",
    outlineWidth: 1,
    font: "Google Sans",
  },

  navigationBar: {
    position: "absolute",
    // margin: '0 16px',
    right: "70px",
    color: "#e6e6e6",
    border: "#333333",
    top: 15,
    // backgroundColor: '#333333',
    fontSize: 18,
    padding: "0 1px",
    display: "block",
    float: "left",
    marginLeft: 10,
    textAlign: "center",
    height: "80",
    // lineHeight: 38
  },

  logo: {
    height: 50,
    width: 50,
  },
});

export default styles;
